import { compare } from './compare';
import type { Mode, Politician } from './types';

const EMOJI = { correct: '🟩', partial: '🟧', wrong: '🟥' } as const;
const MAX_ROWS = 8;

/** 1 pokus, 2–4 pokusy, 5+ pokusov. */
export function pokusy(n: number): string {
  if (n === 1) return '1 pokus';
  if (n >= 2 && n <= 4) return `${n} pokusy`;
  return `${n} pokusov`;
}

export function shareText(mode: Mode, day: number, guesses: Politician[], target: Politician): string {
  const lines = [`Politikdle #${day} · ${mode === 'classic' ? 'Klasika' : 'Fotka'} 🇸🇰`, `Uhádnuté na ${pokusy(guesses.length)}`];
  const rows =
    mode === 'classic'
      ? guesses.map((g) => compare(g, target).map((c) => EMOJI[c.verdict]).join(''))
      : [guesses.map((g) => (g.id === target.id ? '🟩' : '🟥')).join('')];
  lines.push(...rows.slice(0, MAX_ROWS));
  if (rows.length > MAX_ROWS) lines.push(`… a ďalšie ${rows.length - MAX_ROWS}`);
  lines.push(location.origin + location.pathname);
  return lines.join('\n');
}

/** Native share sheet on phones, clipboard elsewhere. Resolves to what happened. */
export async function share(text: string): Promise<'shared' | 'copied' | 'failed'> {
  if (navigator.share && matchMedia('(pointer: coarse)').matches) {
    try {
      await navigator.share({ text });
      return 'shared';
    } catch (err) {
      if ((err as DOMException).name === 'AbortError') return 'shared';
    }
  }
  try {
    await navigator.clipboard.writeText(text);
    return 'copied';
  } catch {
    return 'failed';
  }
}
